import { SettingOutlined } from '@ant-design/icons';
import { Button, Dropdown, Flex, Image, Layout, Typography } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import useAuth from '../../auth/useAuth';
import { UserRoleType } from '../../constants';
import useRoles from '../../hooks/useRoles';
import { White } from '../../styles';

const { Header } = Layout;
const { Text } = Typography;

const StyledHeader = styled(Header)`
  padding: 0 24px;
  background: ${White};
`;

const StyledImage = styled(Image)`
  cursor: pointer;
`;

function NavBar({ signupComplete }) {
  const navigate = useNavigate();
  const { user, isAuthenticated, loginWithRedirect, logout } = useAuth();
  const { roles } = useRoles();
  const imgixUrl = process.env.REACT_APP_IMGIX_URL;

  const settingsItems = [
    {
      key: '1',
      label: 'Account Settings',
      onClick: () => navigate('/settings/account'),
    },
    {
      key: '2',
      label: 'User Settings',
      onClick: () => navigate('/settings/user'),
    },
    {
      key: '3',
      label: 'Token Usage',
      onClick: () => navigate('/settings/tokens'),
    },
  ];

  return (
    <StyledHeader>
      <Flex align="center" justify="space-between" gap={24}>
        <StyledImage
          alt="logo"
          preview={false}
          width={175}
          src={`${imgixUrl}/static/fathom-logo.svg`}
          onClick={() => navigate('/')}
        />
        <Flex align="center" gap={8}>
          {signupComplete && (
            <>
              {isAuthenticated && <Text>Welcome, {user.name}</Text>}
              {roles.includes(UserRoleType.ADMINISTRATOR) && (
                <Dropdown menu={{ items: settingsItems }} placement="bottomRight">
                  <Button icon={<SettingOutlined />} type="text" size="large" />
                </Dropdown>
              )}
              {isAuthenticated ? (
                <Button
                  data-cy="logout-button"
                  onClick={() => {
                    window.Intercom('shutdown');
                    logout();
                  }}
                >
                  Log out
                </Button>
              ) : (
                <Button type="primary" onClick={() => loginWithRedirect()}>
                  Log in
                </Button>
              )}
            </>
          )}
        </Flex>
      </Flex>
    </StyledHeader>
  );
}

NavBar.propTypes = {
  signupComplete: PropTypes.bool.isRequired,
};

export default NavBar;
